var map = {
	".": [
		32891,
		9
	],
	"./": [
		32891,
		9
	],
	"./index": [
		32891,
		9
	],
	"./index.tsx": [
		32891,
		9
	],
	"./lottie-animations/confetti-page.json": [
		51259,
		3,
		880
	],
	"./lottie-animations/confetti.json": [
		629,
		3,
		629
	],
	"./types": [
		17971,
		9,
		971
	],
	"./types.ts": [
		17971,
		9,
		971
	],
	"./useLottieAnimation": [
		89022,
		9
	],
	"./useLottieAnimation.ts": [
		89022,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 12721;
module.exports = webpackAsyncContext;